import React from 'react';

const Bubble = () => {
  return (
    <svg
      width="222"
      height="350"
      viewBox="0 0 222 350"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222 6.3834C207.044 2.2235 191.282 0 175 0C78.3502 0 0 78.3502 0 175C0 271.65 78.3502 350 175 350C191.282 350 207.044 347.777 222 343.617V6.3834Z"
        fill="#0057FF"
      />
    </svg>
  );
};

export default Bubble;
